var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 18.3333C7.88333 18.3333 5.83333 16.2833 5.83333 13.75V5C5.83333 3.15833 7.325 1.66667 9.16667 1.66667C11.0083 1.66667 12.5 3.15833 12.5 5V12.0833C12.5 13.2333 11.5667 14.1667 10.4167 14.1667C9.26667 14.1667 8.33333 13.2333 8.33333 12.0833V5.83333H10V12.1583C10 12.6167 10.8333 12.6167 10.8333 12.1583V5C10.8333 4.08333 10.0833 3.33333 9.16667 3.33333C8.25 3.33333 7.5 4.08333 7.5 5V13.75C7.5 15.3583 8.80833 16.6667 10.4167 16.6667C12.025 16.6667 13.3333 15.3583 13.3333 13.75V5.83333H15V13.75C15 16.2833 12.95 18.3333 10.4167 18.3333Z",
    fill: "#223CDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.238c48f3499beed19636a2049aab83f1.svg";
export { ForwardRef as ReactComponent };